import React from 'react';

import './Modals.css'


interface DeleteModalProps {
  title: string;
  description: React.ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
  children?: React.ReactNode;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  title,
  description,
  onConfirm,
  onCancel,
  children,
}) => {
  return (
    <div className="modal-backdrop">
      <div className="modal">
        <h2>{title}</h2>
        <div>{description}</div>
        {children}
        <div className="modal-actions">
          <button className="btn" onClick={onCancel}>Annulla</button>
          <button className="btn primary" onClick={onConfirm}>Conferma</button>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;
